// extracted by mini-css-extract-plugin
module.exports = {"tipContent":"ageTipsModal_tipContent__Yz5AS"};